export const DEFAULT_SERVICE_CONFIG = {
    rsaNote: "Free Roadside Assistance (RSA)",
    rsaNoteSuffix: "with Cars24 Platinum cover purchase",
    headerTitle: "Cars24 car servicing",
    whatsCoveredLabel: "What’s covered?",
    marketCompareLabel: "Market comparison",
    serviceIncludesLabel: "Services include :",
    serviceIncludesList: [
        "Full vehicles inspection",
        "Top up engine oil",
        "Engine Oil filter replacement",
        "Perform tyre rotation",
        "Digital Diagnostic Scan",
        "Road test vehicle",
        "Top up windscreen washer fluid",
        "Test battery condition"
    ],
    whatsCovered: {
        sections: [{
            title: "Car maintenance - Servicing",
            items: [
                "Servicing at 12 month / 10,000km",
                "Completed by skilled Cars24 technicians at our local service centre",
                "Lock in attractive prices"
            ]
        }]
    },
    marketCompareData: {
        tableColumns: [
            { key: "feature", title: "Feature" },
            { key: "cars24", title: "Cars24" },
            { key: "manufacturer", title: "Manufacturer" }
        ],
        tableRows: [
            { feature: "Price/premium service", cars24: "$299 (Best value)", manufacturer: "$399+" },
            { feature: "Locked in price", cars24: "Upto 3 years", manufacturer: "No" },
            { feature: "Tyre credit", cars24: "Upto $200", manufacturer: "No" }
        ]
    },
    compareTabs: [
        { key: "service", label: "Service" },
        { key: "warranty", label: "Warranty" }
    ]
};

export const DEFAULT_WARRANTY_CONFIG = {
    rsaNote: "Free Roadside Assistance (RSA)",
    rsaNoteSuffix: "with Cars24 Platinum cover purchase",
    headerTitle: "Cars24 extended warranty",
    whatsCoveredLabel: "What’s covered?",
    marketCompareLabel: "Market comparison",
    compareTabs: [
        { key: "service", label: "Service" },
        { key: "warranty", label: "Warranty" }
    ],
    whatsCovered: {
        sections: [{
            title: "Extended warranty cover",
            tabs: [
                {
                    label: "Mechanical",
                    items: [
                        "Engine",
                        "Cooling",
                        "Drivetrain",
                        "Ignition",
                        "Steering",
                        "Fuel system",
                        "Differential",
                        "Timing belt",
                        "Driveshaft",
                        "Clutch",
                        "Transmission",
                        "Gearbox"
                    ]
                },
                {
                    label: "Electrical",
                    items: [
                        "Computers",
                        "Starter motor",
                        "ECUs",
                        "Alternator",
                        "Power windows",
                        "ABS brake system",
                        "Air conditioning"
                    ]
                }
            ]
        }]
    },
    marketCompareData: {
        tableColumns: [
            { key: "feature", title: "Feature" },
            { key: "cars24", title: "Cars24" },
            { key: "avgCover", title: "Avg. cover" }
        ],
        tableRows: [
            { feature: "Parts covered", cars24: "Manufacturer level", avgCover: "Limited items" },
            { feature: "Number of claims", cars24: "Unlimited", avgCover: "Limited" },
            { feature: "Claim limit", cars24: "Upto value of car", avgCover: "$5000 per claim" },
            { feature: "Claims management", cars24: "Cars24 staff", avgCover: "Third parties" },
            { feature: "Coverage", cars24: "Nationwide", avgCover: "Limited" }
        ]
    }
};

export const DEFAULT_BUNDLE_CONFIG = {
    headerTitle: "Cars24 Car Cover Bundles",
    comparisonTitle: "Why is Cars24 platinum cover the best?",
    whatsCovered: {
        orderMap: {
            rsa: 1,
            warranty: 2,
            service: 3
        }
    }
};
